import {Button, Card, CardContent, CardHeader} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import PlayIcon from '../../../assets/images/svgicons/play.svg';
import defaultImg from '../../../assets/images/default-image-library.png';
import {useNavigate} from 'react-router-dom';
import Search from '../../common/Search';
import {useEffect, useLayoutEffect, useState} from 'react';
import useVideoTutorialHook from '../../../hooks/useVideoTutorialHook';
import useSearchhook from '../../../hooks/useSearchhook';
import {librarySearch} from '../../../lib/utils';
import { APPROUTES } from '../../../assets/constants/constants';
import withAlmToken from '../../common/withAlmToken';
import PageLoader from '../../common/loader/PageLoader';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import useAlmCorporateStatus from '../../../hooks/useAlmCorporateStatus';

const VideoTutorials = () => {
  const [searchedData, setSearchedData] = useState<any>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isVideoTutorialData } = useVideoTutorialHook();
  const { keyword, onhandleSearch, onSearchClick } = useSearchhook();
  const [loading, setLoading] = useState(true);
   useAlmCorporateStatus();

  useEffect(() => {
    setLoading(true);
    if (keyword) {
      const searchResult = librarySearch(keyword, isVideoTutorialData);
      setSearchedData(searchResult);
      setTimeout(() => setLoading(false), 2000);
    } else {
      setSearchedData(isVideoTutorialData);
      setTimeout(() => setLoading(false), 2000);
    }
  }, [keyword, isVideoTutorialData]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
        <div className="flex justify-between items-center md:pl-2">
          <Button
            onClick={() => navigate(-1)}
            variant="default"
            className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
          >
            <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
          <Search
            onSearchClick={onSearchClick}
            onhandleSearch={onhandleSearch}
          />
        </div>
        <h2
          className="text-3xl font-barlowLight mt-6 pl-2"
          dangerouslySetInnerHTML={{ __html: t("MyStance.videoTutorials") }}
        />

        <div
          className="grid grid-cols-4 gap-x-6 gap-y-28 mt-12"
          style={{ display: "none" }}
        ></div>
        <div className="flex -ml-4 lg:flex-row md:flex md:flex-row flex-wrap gap-y-6 mt-12">
          {searchedData?.length > 0 ? (
            <>
              {searchedData?.map((res: any) => {
                return (
                  <div className="min-w-0 shrink-0 grow-0 basis-full pl-4 landscape:2xl:basis-1/4 landscape:xl:basis-1/3 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                    <Card className="w-full h-full p-0 bg-fillMidGrayCard border-cardBorder relative flex flex-col flex-1">
                      <CardHeader className="p-0 min-h-[130px]">
                        <div className={`relative cursor-pointer]`}>
                          {res?.attributes?.imageUrl ? (
                            <img
                              src={res?.attributes?.imageUrl}
                              alt={' '}
                              className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                            />
                          ) : (
                            <img
                              src={defaultImg}
                              alt={" "}
                              className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                            />
                          )}
                          <img
                            onClick={() =>
                              navigate(
                                `/video-tutorial-details/${
                                  res?.id
                                }?courseType=${"Vidoes"}`,
                                { state: { from: APPROUTES.video_tutorials } }
                              )
                            }
                            src={PlayIcon}
                            alt={" "}
                            className="absolute center-icon cursor-pointer"
                          />
                        </div>
                      </CardHeader>
                      <CardContent className="mt-2">
                        <div className="flex flex-col gap-6 p-2">
                          <p className="text-sm font-barlowLight text-white leading-tight hidden">
                            {"Inner Stance App"}
                          </p>
                          <p className="text-2xl  font-barlowLight text-white leading-tight ">
                            {getLocalizedContent(res?.attributes?.localizedMetadata)?.name}
                          </p>
                          <hr className=" h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10 " />
                          <p className="text-xl font-barlowLight text-white leading-tight ">
                            {getLocalizedContent(res?.attributes?.localizedMetadata)?.description}
                          </p>
                        </div>
                      </CardContent>
                      <div className="mt-auto p-6">
                        <Button
                          onClick={() =>
                            navigate(
                              `/video-tutorial-details/${
                                res?.id
                              }?courseType=${"Videos"}`,
                              {
                                state: { from: APPROUTES.video_tutorials },
                              }
                            )
                          }
                          className="w-full cursor-pointer text-base font-barlowMedium"
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: t("VideoTutorials.buttonText"),
                            }}
                          />
                        </Button>
                      </div>
                    </Card>
                  </div>
                );
              })}
            </>
          ) : (
            <div className="flex justify-center items-center h-64 w-full text-2xl">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("Videos.noDetailsFound"),
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withAlmToken(VideoTutorials);
